import { createAction } from 'typesafe-actions'

export const setShouldNavigateToTarget = createAction('DOC / navigation / set state')<boolean>()
